import { TCompanyHeaderInfo } from "@/frontend/features/Company/model/types/types";
import { TGetPortfolioCompany } from "@/libs/models/portfolio-companies";

export function getCompanyShortInfo(data?: TGetPortfolioCompany): TCompanyHeaderInfo {
  const id = data?.id || data?.companyData?.id || 0;
  const name = data?.name || data?.companyData?.name || "";
  const logoUrl = data?.logoUrl || data?.companyData?.logoUrl || null;
  const headline = data?.headline || data?.companyData?.headline || null;
  const website = data?.website || data?.companyData?.website || null;
  const linkedInUrl = data?.linkedInUrl || data?.companyData?.linkedInUrl || null;
  const facebookUrl = data?.facebookUrl || data?.companyData?.facebookUrl || null;
  const twitterUrl = data?.twitterUrl || data?.companyData?.twitterUrl || null;
  const phone = data?.phone || data?.companyData?.phone || null;
  const email = data?.email || data?.companyData?.email || null;
  const harmonicTags = data?.companyData?.harmonicTags || [];
  const companyId = data?.companyData?.id || 0;
  return {
    id,
    name,
    logoUrl,
    headline,
    website,
    linkedInUrl,
    facebookUrl,
    twitterUrl,
    phone,
    email,
    harmonicTags,
    companyId
  };
}
